import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'tramites/complementos-de-tramites/';

/**
 * GET Complementos de Tramites
 * param {object} params
 * @returns {Promise<object>}
 */
export const getComplementosDeTramites = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Complemento de Tramite
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getComplementoDeTramite = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Complemento de Tramite
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postComplementoDeTramite = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Complemento de Tramite
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchComplementoDeTramite = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Complemento de Tramite
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteComplementoDeTramite = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
